import { Helmet } from "react-helmet";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import styles from "./WoodenDesignPlate.module.css";

//Reusable Section
import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";
import EditScreenScrollHead from "../../Reusables/EditScreenScrollHead";
//Sample Images

import sample_A1 from "../../../assets/images/edit_screen/WoodenDesignPlate/A_1.png";
import sample_A2 from "../../../assets/images/edit_screen/WoodenDesignPlate/A_2.png";
import sample_B1 from "../../../assets/images/edit_screen/WoodenDesignPlate/B_1.png";
import sample_B2 from "../../../assets/images/edit_screen/WoodenDesignPlate/B_2.png";
import sample_C1 from "../../../assets/images/edit_screen/WoodenDesignPlate/C_1.png";
import sample_C2 from "../../../assets/images/edit_screen/WoodenDesignPlate/C_2.png";

import EditScreenSamplePhotoGrid9 from "../../Reusables/EditScreenSamplePhotoGrid9";
import WoodenDesignPlateReusable from "./WoodenDesignPlateReusable";

import { createRef, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { scroller } from "react-scroll";
import save_icon from "../../../assets/images/icons/save_icon.png";
import useAxios from "../../Hooks/useAxios";
import Loading from "../../Loading/Loading";
import PhotoSelection from "../PhotoSelection/PhotoSelection";
import SinglePreviewFromEditState from "./WDP_SinglePreviewFromEditState";

const WoodenDesignPlate = () => {
  const MAX_ITEMS = 50;
  const { product_id } = useParams();
  const childRefs = useRef(
    Array(MAX_ITEMS)
      .fill(null)
      .map(() => createRef())
  );

  const [showBottomPreviews, setShowBottomPreviews] = useState(false);
  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(false);

  const [copyDetails, setCopyDetails] = useState([]);
  //SO here callback will not change the parent state
  //callback will save the states for future use and copy mechanisms

  //Default PhotoArray
  let defaultPhotoArray = [
    {
      src: "",
      id: 1,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: 2,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: 3,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: 4,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: -1,
    },
    {
      src: "",
      id: 6,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: 7,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: 8,
      photoSelected: false,
      zoomLevel: 1,
    },
    {
      src: "",
      id: 9,
      photoSelected: false,
      zoomLevel: 1,
    },
  ];

  let defaultStateSingleProduct = {
    choice: "A",
    name: "",
    ageInMonths: "",
    plan: "",
    date: "",
    DOBWestern: "",
    birthTime: "",
    birthWeight: "",
    birthHeight: "",
    imageLeftCount: 8,
    images: defaultPhotoArray,
    copied: false,
  };

  const [previewImages, setPreviewImages] = useState([]);
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;

  const [showSelectionPopup, setShowSelectionPopup] = useState(false);

  const [imagesLeft, setImagesLeft] = useState(0);
  const [currentImageSelectionIndex, setCurrentPhotoSelectionIndex] =
    useState(-1);
  const [psk, setpsk] = useState(0);
  const [selectedImageSlot, setSelectedImageSlot] = useState(-1);
  let [editState, setEditState] = useState([]);
  const imageSelectionPopup = (index, count, selectedSlot = -1) => {
    setShowSelectionPopup(true);
    setImagesLeft(count);
    setCurrentPhotoSelectionIndex(index);
    setpsk(psk + 1);
    setSelectedImageSlot(selectedSlot);
  };
  const onPhotoSelectionEnd = (photo_url) => {
    setShowSelectionPopup(false);
    const temp = JSON.parse(JSON.stringify(editState));
    let picIdx = 0;
    if (selectedImageSlot === -1) {
      for (let i = 0; i < 9; i++) {
        if (picIdx >= photo_url.length) break;
        if (temp[currentImageSelectionIndex].images[i].id === -1) {
          continue;
        } else if (temp[currentImageSelectionIndex].images[i].src === "") {
          temp[currentImageSelectionIndex].images[i].src = photo_url[picIdx++];
        }
      }
    } else {
      for (let i = 0; i < 9; i++) {
        if (
          temp[currentImageSelectionIndex].images[i].id === selectedImageSlot
        ) {
          temp[currentImageSelectionIndex].images[i].src = photo_url[picIdx++];
        }
      }
    }

    setEditState(temp);
  };

  const changeEditState = (index, state) => {
    const temp = Array.from(editState);
    temp[index] = state;
    setEditState(temp);
  };
  const changePreviewImage = (index, newImage) => {
    const temp = Array.from(previewImages);
    temp[index] = newImage;
    setPreviewImages(temp);
  };

  const confirmEdits = async () => {
    setLoading(true);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    const tempPreviewImages = [];
    for (let i = 0; i < previewImages.length; i++) {
      if (!previewImages[i]) {
        const file = await childRefs.current[i].current.changePreview();
        if (!file) {
          alert("Preview(s) was not generated");
          return;
        } else {
          tempPreviewImages.push(file);
        }
      } else {
        tempPreviewImages.push(previewImages[i]);
      }
    }

    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));
    data.append("copy_details", JSON.stringify(copyDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    for (let i = 0; i < tempPreviewImages.length; i++) {
      const image = tempPreviewImages[i];
      data.append("preview_images_" + i, image, "image" + i + ".png");
    }

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          setLoading(false);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", { state: { title : "アルバム", subtitle : "", count : count, address : "", item : item } });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e);
      });
  };

  const saveToServer = () => {
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }
    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
      copy_details: JSON.stringify(copyDetails),
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const [count, setCount] = useState(0);

  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(res.data.quantity);
          console.log(design.design_status);
          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
            setCopyDetails(JSON.parse(design.copy_details));
            let tempPreviewImages = [];
            for (let i = 0; i < res.data.quantity; i++) {
              tempPreviewImages.push(0);
            }
            setPreviewImages(tempPreviewImages);
          } else {
            let tempState = [];
            let tempPreviewImages = [];
            let tempCopyDetails = [];
            for (let i = 0; i < res.data.quantity; i++) {
              const temp = JSON.parse(
                JSON.stringify(defaultStateSingleProduct)
              );

              tempState.push(temp);
              tempPreviewImages.push(0);
              tempCopyDetails.push(i + 1);
            }
            console.log("Initial EDIT State:");
            console.log(tempState);
            setEditState(tempState);
            setPreviewImages(tempPreviewImages);
            setCopyDetails(tempCopyDetails);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const generatePreviewsAtBottom = async () => {
    console.log("----GENERATING BOTTOM PREVIEWS----");
    console.log(previewImages);
    const previewPromises = previewImages.map(async (image, i) => {
      if (!editState[i].copied) {
        const file = await childRefs.current[i].current.changePreview();
        if (!file) {
          alert("Preview(s) was not generated");
          return 0;
        } else {
          console.log("Here's the file from parent");
          console.log(file);
          return file;
        }
      } else {
        return image;
      }
    });

    const tempPreviewImages = await Promise.all(previewPromises);

    console.log("PREVIEW IMAGES HERE:");
    console.log(tempPreviewImages);
    console.log("ALL preview images generate");
    setPreviewImages(tempPreviewImages);
    setShowBottomPreviews(true);
  };

  const changeCopyDetails = async (details, index) => {
    console.log("CHANGE COPY DETAILS");
    console.log(index);
    console.log(details);
    const newDetails = JSON.parse(JSON.stringify(copyDetails));
    newDetails[index] = details;
    setCopyDetails(newDetails);
    let tempState = JSON.parse(JSON.stringify(editState[details - 1]));
    tempState.showPreview = false;
    tempState.copied = index !== details - 1;
    changeEditState(index, tempState);

    if (index === details - 1) {
      return;
    }

    const tempPreviewImages = Array.from(previewImages);
    console.log("COPY DETAILS");
    console.log(index);
    console.log(details);
    console.log(previewImages[details - 1]);
    const file = await childRefs.current[details - 1].current.changePreview();

    console.log("file from parent");
    console.log(file);
    if (!file) {
      alert(" Preview was not generated");
      return;
    } else {
      console.log("Here's the file from parent");
      console.log(file);
      tempPreviewImages[details - 1] = file;
      tempPreviewImages[index] = tempPreviewImages[details - 1];
    }

    console.log(tempPreviewImages);
    setPreviewImages(tempPreviewImages);
  };
  <Helmet>
    <script>
      {`(function(d) {
      var config = {
          kitId: 'tnx5lwp',
          scriptTimeout: 3000,
          async: true
        },
        h = d.documentElement,
        t = setTimeout(function() {
          h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
        }, config.scriptTimeout),
        tk = d.createElement("script"),
        f = false,
        s = d.getElementsByTagName("script")[0],
        a;
      h.className += " wf-loading";
      tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
      tk.async = true;
      tk.onload = tk.onreadystatechange = function() {
        a = this.readyState;
        if (f || a && a != "complete" && a != "loaded") return;
        f = true;
        clearTimeout(t);
        try {
          Typekit.load(config)
        } catch (e) {}
      };
      s.parentNode.insertBefore(tk, s)
    })(document)`}
      ;
    </script>
  </Helmet>;
  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      {showSelectionPopup && (
        <PhotoSelection
          skey={psk}
          count={imagesLeft}
          done={onPhotoSelectionEnd}
          allowLessSelects={true}
        />
      )}
      {!showSelectionPopup && (
        <div className={styles.wooden_square_edit_screen_main_div}>
          {count > 0 && (
            <div onClick={saveToServer} className={styles.save_box_main}>
              <img
                src={save_icon}
                className={styles.save_icon_image}
                alt="save"
              />
            </div>
          )}
          <DesignBoxNavigationCrumb active={3} />
          <EditScreenItemHeaderDiv
            title={"木製デザインプレート"}
            subtitle={"マット 正方形M"}
            count={count}
            address={"会員様住所"}
            item={item}
          />
          <EditScreenHeaderInfoDiv
            lines={[
              "写真のトリミング・文字入れが可能です。",
              "以下の画像を参考にご希望を選択・入力してください。",
            ]}
          />
          <EditScreenScrollHead sections={["文字入れパターン", "編　集"]} />

          <EditScreenSamplePhotoGrid9
            header={"文字入れパターン"}
            subtext={"文字入れパターンを以下の中からお選びください。"}
            imageText={["パターンA", "パターンB", "パターンC"]}
            images={[
              sample_A1,
              sample_A2,
              sample_B1,
              sample_B2,
              sample_C1,
              sample_C2,
            ]}
          />
          {[...Array(count)].map((_, index) => {
            const childRef = childRefs.current[index];
            return (
              <WoodenDesignPlateReusable
                key={index}
                ref={childRef}
                index={index}
                callback={changeEditState}
                callbackPreviewChange={changePreviewImage}
                state={editState[index]}
                image_selection_popup={imageSelectionPopup}
                confirmEdits={confirmEdits}
                //new stuff
                generatePreviewsAtBottom={generatePreviewsAtBottom}
                saveThisProduct={saveToServer}
                changeCopyDetails={changeCopyDetails}
                selectedCopyDetails={copyDetails[index]}
                currentPageNumber={index + 1}
                totalPageNumber={count}
                preview_copied_image={previewImages[index]}
              />
            );
          })}

          {showBottomPreviews && (
            <div className={styles.bottom_previews_main}>
              <div className={styles.bottom_previews_top_hr}></div>
              <div className={styles.bottom_previews_header}>最終確認</div>

              {editState.map((state, index) => {
                return (
                  <div
                    key={index}
                    className={styles.bottom_preview_single_main}
                  >
                    <div
                      className={styles.header_number_2}
                      name={"editsection" + (index + 1)}
                    >
                      {index + 1 + "個目"}
                    </div>
                    <div className={styles.bottom_prev_img01}>
                      <SinglePreviewFromEditState
                        state={state}
                        previewImage={previewImages[index]}
                      />
                    </div>
                    {/* <img
                      className={styles.bottom_prev_img01}
                      src={
                        previewImages[index]
                          ? URL.createObjectURL(previewImages[index])
                          : "0"
                      }
                      alt="prvw img"
                    /> */}
                    <div
                      onClick={() => {
                        const elementName = "editsection" + (index + 1);

                        scroller.scrollTo(elementName, {
                          spy: true,
                          smooth: true,
                          offset: -350,
                          duration: 500,
                        });
                      }}
                      className={styles.scroll_tag99}
                    >
                      編集へ戻る
                    </div>
                  </div>
                );
              })}
              <div className={styles.bottom_preview_text}>
                上記の内容で最終決定しますか？
              </div>
              <div onClick={confirmEdits} className={styles.btm_final_btn}>
                はい
              </div>
            </div>
          )}

          {count === 0 && <div className={styles.nopage_margin_bottom}></div>}
        </div>
      )}
      {loading && <Loading style={{ marginBottom: "50px" }} />}
      <Footer />
    </>
  );
};

export default WoodenDesignPlate;
